import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HomePage from "./pages/home/home";
import LobbyView from "./views/lobbyView/LobbyView";
import NoAccessPage from "./pages/no-access-page/no-access-page";
import LiveEventsView from "./views/LiveEventsView/live-events-view";
import SportView from "./views/SportView/SportView";
import MarketView from "./views/MarketView/MarketView";
import { SnackbarProvider } from "notistack";
import BetListPage from "./pages/BetList/BetList";
import "./scorcardtheme.css";
import SnackbarCloseButton from "./components/SnackBar/CloseSnackBar";

function App() {
  const location = useLocation();
  const [routeName, setRouteName] = useState<string>("");

  useEffect(() => {
    setRouteName(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (
      !(
        routeName === "/lobby" ||
        routeName === "/auth" ||
        routeName === "lobby"
      )
    ) {
      sessionStorage.setItem("currentRoute", routeName);
    }
  }, [routeName]);
  return (
    <SnackbarProvider
      hideIconVariant={true}
      action={(key) => (
        <SnackbarCloseButton snackbarKey={key} />
      )}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      maxSnack={1}
    >
      <div className="App">
        <Routes>
          <Route path="/auth" element={<HomePage />} />
          <Route path="/" element={<Navigate to="auth" />} />
          <Route path="/lobby" element={<LobbyView />}>
            <Route path=":provider/inplay" element={<LiveEventsView />}></Route>
            <Route path=":provider/:sportId" element={<SportView />}></Route>
            <Route
              path="/lobby/:provider/:sportId/:eventId/:competitionId"
              element={<MarketView />}
            ></Route>
            <Route path="/lobby/bet_list" element={<BetListPage />}></Route>
          </Route>
          <Route
            path="/premium/:provider/:sportId/:eventId"
            element={<MarketView />}
          ></Route>
          <Route path="/no-access" element={<NoAccessPage />} />
        </Routes>

        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </SnackbarProvider>
  );
}

export default App;
